export const link = ({ theme: { colors, fonts } }) => ({
    ...fonts.heroNewBold,
    fontSize: '1rem',
    lineHeight: '1.75rem',
    display: 'inline',
    color: colors.cyan,
    textDecoration: 'none',
    borderBottom: `0.125rem solid ${colors.blue}`,
    paddingBottom: '0.0625rem',
    transition: 'cubic-bezier(0.4, 0.0, 0.2, 1) color 0.3s',
    willChange: 'color',
    fontWeight: 700,

    tablet: {
        fontSize: '1.125rem',
        lineHeight: '2.1rem',
    },

    ':hover': {
        color: colors.fuchsia,
    },
});

export const linkWrapper = () => ({
    marginBottom: '1rem',
    marginRight: '2rem',

    tablet: {
        marginBottom: '1.25rem',
    },
});

export const linksRow = () => ({
    flexDirection: 'column',

    tabletLarge: {
        flexDirection: 'row',
    },
});

export const extendTitle = {
    title: ({ theme: { colors } }) => ({
        color: colors.white,
        fontSize: '1.4rem',
        fontWeight: '700',
        marginBottom: '1.5rem',
        marginTop: '1.8rem',

        tablet: {
            marginBottom: '2rem',
        },
    }),
};

export const extendContainer = {
    container: () => ({
        marginBottom: '5rem',

        tablet: {
            marginBottom: 0,
        },

        tabletLarge: {
            gridColumn: 'auto / span 4',
        },

        desktopLarge: {
            gridColumn: 'auto / span 3',
        },
    }),
};
